import React from 'react';
import { RegularButton, Typography } from 'fronton-react';
import {
	contentItemButtonStyles,
	contentItemTextStyles,
	HowToOrderItemContent,
	HowToOrderItemWrapper,
	imgStyles,
	pictureStyles,
} from './styles';

type ImgUrls = {
	lDesk: string;
	tab: string;
	mob: string;
};
type Props = {
	imgUrls: ImgUrls;
	imgAlt: string;
	title: string;
	contentItems: string[];
	dataQa: string;
	buttonText?: string;
	onClick: VoidFunction;
};
export const HowToOrderItem = ({
	imgUrls,
	imgAlt,
	title,
	contentItems,
	buttonText,
	dataQa,
	onClick,
}: Props) => (
	<HowToOrderItemWrapper data-qa={dataQa}>
		<div>
			<picture className={pictureStyles}>
				<source srcSet={imgUrls.mob} media="(max-width: 767px)" />
				<source srcSet={imgUrls.tab} media="(max-width: 1023px)" />
				<source srcSet={imgUrls.lDesk} media="(max-width: 1365px)" />
				<img className={imgStyles} src={imgUrls.lDesk} alt={imgAlt} />
			</picture>
		</div>
		<HowToOrderItemContent>
			<Typography as="h2" variant="h2">
				{title}
			</Typography>
			{contentItems.map(item => (
				<Typography
					key={item}
					className={contentItemTextStyles}
					as="p"
					size="body_long"
					variant="m"
				>
					{item}
				</Typography>
			))}
			<RegularButton
				data-qa={`${dataQa}-button`}
				className={contentItemButtonStyles}
				size="l"
				variant="accent"
				onClick={onClick}
			>
				{buttonText}
			</RegularButton>
		</HowToOrderItemContent>
	</HowToOrderItemWrapper>
);
